export class PartnerShareFacebookConnectionListRow {
  constructor(
    public readonly id: number,
    public readonly companyName: string,
    public selected: boolean,
  ) {}
}
